import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import Notebook from "@common/images/notebook-icon.svg";
import NotebookHover from "@common/images/notebook-icon-hover.svg";
import NotebookCollapse from "@common/images/notebook-icon-collapse.svg";
import { Image } from "@learningblocks/shared-components";
import style from "./style.module.scss";

const ENTER_KEY = 13;
/**
 * DrawerIcon: The handle component for NotebookDrawer
 * Used to collapse and expand Drawer
 */
export function DrawerIcon(props) {
  const [hover, setHover] = React.useState(false);
  const intl = useIntl();

  const mouseOver = () => setHover(true);
  const mouseOut = () => setHover(false);

  const getHandleIcon = () => {
    if (props.collapsed) return NotebookCollapse;
    else if (hover) return NotebookHover;
    else return Notebook;
  };

  const getClassName = () => {
    let className = style.drawerExpanded;
    if (props.collapsed) {
      className = style.drawerCollapsed;
    }
    return `${className} ${props.className}`;
  };

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.toggleCollapse(!props.collapsed);
  };

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.toggleCollapse(!props.collapsed);

  return (
    <span
      tabIndex="0"
      role="button"
      className={getClassName()}
      onMouseOver={mouseOver}
      onFocus={mouseOver}
      onMouseOut={mouseOut}
      onBlur={mouseOut}
      onKeyDown={onKeyDown}
      onClick={onClick}
    >
      <Image
        src={getHandleIcon()}
        alt={intl.formatMessage({
          id: "Notebook display button. Select to show or hide the notebook.",
          defaultMessage:
            "Notebook display button. Select to show or hide the notebook.",
          description: "",
        })}
      />
    </span>
  );
}

DrawerIcon.propTypes = {
  /**
   * Function invoked to collapse or expand NotebookDrawer
   */
  toggleCollapse: PropTypes.func.isRequired,
  /**
   * Boolean specifying if Drawer is Collapsed
   */
  collapsed: PropTypes.bool.isRequired,
  /**
   * className
   */
  className: PropTypes.string,
};
